var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33L15 24H3L6 33H18ZM18 33H24",
    stroke: "#5C11A7",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5V18.75C18 15.9216 18 14.5074 17.1213 13.6287C16.2426 12.75 14.8284 12.75 12 12.75C9.17157 12.75 7.75736 12.75 6.87869 13.6287C6 14.5074 6 15.9216 6 18.75V19.5",
    stroke: "#5C11A7",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19.5C28.5 21.1569 27.1569 22.5 25.5 22.5C23.8431 22.5 22.5 21.1569 22.5 19.5C22.5 17.8431 23.8431 16.5 25.5 16.5C27.1569 16.5 28.5 17.8431 28.5 19.5Z",
    stroke: "#5C11A7",
    strokeWidth: 2.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15 7.65686 13.6569 9 12 9C10.3431 9 9 7.65686 9 6C9 4.34314 10.3431 3 12 3C13.6569 3 15 4.34314 15 6Z",
    stroke: "#5C11A7",
    strokeWidth: 2.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.25H30C31.6569 26.25 33 27.5931 33 29.25V30C33 31.6569 31.6569 33 30 33H28.5",
    stroke: "#5C11A7",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesIcon);
export default __webpack_public_path__ + "static/media/updates-icon.8d39fd59923cd6ff71797fa4c17826f7.svg";
export { ForwardRef as ReactComponent };